<template>
    <div>
        <!-- 录入报价 -->
        <compFormQuery class="margin-top-15 margin-right-15" :formdata="getBase" :value="entrydata" :labelWidth="140"></compFormQuery>
        <div class="margin-left-15 margin-right-15">
            <vButton class="margin-right-5" theme="success" @click="importexcel">批量导入</vButton>
            <vButton class="margin-right-5" theme="error" @click="clearAll">全部清空</vButton>

            <vButton class="pull-right" theme="primary" @click="exportexcel">导出</vButton>
        </div>
        <div class="color-error margin-left-15 margin-top-10">报价审核通过后，将以报价公司名称自动创建一个待审核的供应商；如果报价公司在供应商管理中已建档，填写时请保持与建档名称一致。</div>
        <vTable
            class="margin-15"
            :columns="columns" 
            :data="datalist"
            size="small" 
            ref="table"  
            border 
        ></vTable>

        <div class="margin-left-15">
            <vButton theme="info" @click="exportfile">附件上传</vButton>
        </div>
        <vTable
            class="margin-20"
            :columns="doccolumns" 
            :data="docList"
            size="small" 
            ref="tablequery"  
            border
        ></vTable>

        <div class="text-right margin-right-15">
            <vButton class="margin-right-5" theme="info" @click="saveAduit">提交审核</vButton>
            <vButton @click="closebox">关闭</vButton>
        </div>

        <!-- 全局弹框 -->
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps={}"
		>
            <component ref="cusref" :is="modalProps.component" @on-close="modalProps={}" v-bind="modalProps" v-on="modalProps.on"></component>
        </compModal>
    </div>
</template>

<script>
import { HttpGetOfferList, HttpSaveOfferOne, HttpDeleteOfferOne } from "@/service/proddevelop";
import { HttpDelAttach, HttpDelAttachNew } from "@/service/purchase/purchase";

import compUpdateprice from './updateprice';
import mixin from '../../mixins'
export default {
    mixins: [mixin],
    props:['entrydata'],
    data(){
        return {
            modalProps:{},
            datalist:[],
            attachdata:[],
            // docList:[],
        }
    },
    components: {
        compFormQuery: () => import("@components/templates/formquery"),
        compAttachlog: () => import("@components/templates/attachlog"),
        compUpload: () => import("@components/templates/upload"),
        compUpdateprice,
        
	},
    created(){
        console.log(this.entrydata.docList,'docListdocListdocList')
        this.update()
    },
    computed:{
        doccolumns(){
            // let array = 
            let _this = this
            return [
				{
					title: '附件名称',
					key: 'attachTitle',
                }, 
                {
					title: '附件链接',
                    key: 'attachUrl'
                },
				{
					title: '操作',
					width: 120,
					render(h, { row, index }) {
                        let delButton = ''
                        if (_this.type !== 'query') {
                            delButton = h('vButton', {
                                props: {
                                    theme: "error",
                                    size: 'small',
                                },
                                on: {
                                    click: () => {
                                        _this.remove(index)
                                    }
                                },
                                style: {
                                    'margin-right': '15px'
                                }
                            }, '删除')
                        }
						return h('div', [
							delButton,
                            h('vButton', {
                                props: {
                                    theme: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        _this.downfile(row.attachUrl)
                                    }
                                }
                            }, '下载')
                        ])
					}
				}
			]
        },
        getBase(){
            return [
                {
					label: "预编码",
					key: "precoding",
                },
                {
					label: "报价单状态",
                    key: "orderstatus",
                    tag: "vSelect",
                    options:this.getPrimaryStatus,

                },
                {
					label: "申请人",
					key: "submitterName",
                },
                {
					label: "申请时间",
					key: "submitTime",
				},
            ]
        },
        columns(){
            return [
                {
					title: '报价公司名称',
					key: 'companyName',
                }, 
                {
					title: '生产周期（天）',
					key: 'productionCycle',
                }, 
                {
					title: '最小起订量',
					key: 'minOrderQty',
                }, 
                {
					title: '报价（USD）',
					key: 'offerUsd',
                }, 
                {
					title: '报价（CNY）',
					key: 'offerCny',
                }, 
                {
					title: '报价有效期',
					key: 'validPeriodTime',
                }, 
                {
                    title: '操作',
                    width:200,
                    render:(h, { row, index })=>{
						return h('div', [
							h('Button', {
								props: {
									type: "primary",
									size: 'small'
								},
								on: {
									click: () => {
										this.querydetail(row)
									}
                                },
                                style:"margin-right:5px"
                            }, '查看全部'),
                            h('Button', {
								props: {
									type: "warning",
									size: 'small'
								},
								on: {
									click: () => {
										this.editdetail(row,index)
									}
                                },
                                style:"margin-right:5px"
                            }, '编辑'),
                            h('Button', {
								props: {
									type: "error",
									size: 'small'
								},
								on: {
									click: () => {
										this.removeone(row,index)
									}
								}
							}, '删除'),
						])
					}
                }, 
            ]
        }
    },
    methods:{
        update(){
            HttpGetOfferList({
                'search[EQ_preselectionId]':this.entrydata.orderid,
                row:20,
                page:1,
            }).then(res=>{
                // console.log(res.data)
                this.datalist = res.data.content;
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
            this.docList = this.entrydata.docList
        },
        querydetail(row){
            this.modalProps = {
                show: true,
                title: '查看详情',
                width:1000,
                showFooter: false,
                component: "compUpdateprice",
                querytype:'query',
                oneid:row.id,
            }
        },
        editdetail(row,index){
            // 点击编辑按钮
            this.modalProps = {
                show: true,
                title: '编辑详情',
                width:1000,
                showFooter: false,
                component: "compUpdateprice",
                querytype:'edit',
                oneid:row.id,
                orderid:this.entrydata.orderid,
                on:{
                    'on-update':(data)=>{
                        // console.log(data,'123324232342')
                        this.datalist[index] = data;
                        this.modalProps = {}
                    }
                }
            }
        },
        clearAll(){
            this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
                    this.dataList = [];
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
        },
        removeone(row,index){
            this.datalist.splice(index, 1);
            HttpDeleteOfferOne({
                ids:row.id
            }).then(res=>{
                this.$VMessage.success(res.message)
            })
        },
        downfile(url){
            this.handleWebfs(url, {}, 'download')
        },
        remove (index, useId) {
            // 新增时删除附件用另外的接口
            if (this.type === 'add') {
                HttpDelAttachNew({
                    id: useId ? index : this.docList[index].attachId
                }).then(res => {
                    if (!useId) {   
                        this.docList.splice(index, 1)
                        this.$VMessage.success(res.message)
                    }
                }, err => {
                    if (!useId) {
                        this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                    }
                })
            }
            // 编辑
            else {
                HttpDelAttach({
                    id: this.entrydata.orderid || 0,
                    attachId: useId ? index : this.docList[index].attachId
                }).then(res => {
                    if (!useId) {
                        this.docList.splice(index, 1)
                        this.$VMessage.success(res.message)
                    }
                }, err => {
                    if (!useId) {
                        this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
                    }
                })
            }
        },
        importexcel(){
            // 点击导入按钮
            this.modalProps = {
                show: true,
                title: '批量导入',
                width:460,
                showFooter: false,
                data: {preselectionId:this.entrydata.orderid,},
                action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentOffer/import",
                name: "excelFile",
                component: "compUpload",
                on:{
                    'on-success':(res)=>{
                        this.datalist = res.data;
                        this.update();
                        this.modalProps = {};

                    }
                }
            }
        },
        exportexcel(){
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentOffer/export', {type:0,preselectionId:this.entrydata.orderid}, 'download')
        },
        exportfile(){
            this.modalProps = {
                show: true,
                title: '添加附件',
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.entrydata.orderid || 0,
                    model: 'pd_preselection',
                    type: 'other',
                },
                showFooter: false,
                action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
                name: "multipartFile",
                multiple: true,
                on:{
                    'on-success':(res)=>{
                        // console.log(res)
                        let flag = false
                        if ((res.items.length + this.docList.length) > 5) {
                            this.$VMessage.error('附件数量过多，请打包后上传')
                            flag = true
                        }
                        res.items.map((item) => {
                            if (flag) {
                                this.remove(item.attachId, true)
                            }
                            else {
                                this.docList.push(item)
                            }
                        })
                        this.modalProps={}
                    },
                    'on-cancel':()=>{
                        this.modalProps={}
                    }
                },
			};
        },
        closebox(){
            this.$emit('on-close')
        },
        saveAduit(){
            this.datalist.map(item=>{
                item.status = 1
            })
            HttpSaveOfferOne(this.datalist).then(res=>{
                this.$VMessage.success(res.message);
                this.$emit('on-update')
                this.update()
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        }
    }
}
</script>